import { defineStore } from 'pinia'
import { theme } from 'ant-design-vue'
import { ref, computed } from 'vue'

export const useDesignStore = defineStore('designStore', () => {
  const modeltheme = ref<any>('')

  const changeModeltheme = () => {
    modeltheme.value = modeltheme.value ? '' : theme.darkAlgorithm
  }

  return {
    theme: computed(() => modeltheme.value),
    changeModeltheme
  }
})
